module.exports = __webpack_public_path__ + "img/icon4.a32abeb7.png";